import api from './api';

export interface OrcamentoMeta {
  id: string;
  metaId: string;
  valor?: number;
  nomeOriginal?: string;
  nomeArquivo?: string;
  mimeType?: string;
  tamanhoBytes?: number;
  descricao?: string;
  usuarioUpload?: string;
  dataUpload?: string;
  viewUrl?: string;
}

const orcamentoMetaService = {
  listByMeta: async (metaId: string): Promise<OrcamentoMeta[]> => {
    const res = await api.get(`/orcamento-meta/meta/${metaId}`);
    return res.data;
  },

  upload: async (metaId: string, payload: { file: File; valor?: number; descricao?: string }): Promise<OrcamentoMeta> => {
    const formData = new FormData();
    formData.append('file', payload.file);
    if (payload.valor != null) formData.append('valor', String(payload.valor));
    if (payload.descricao) formData.append('descricao', payload.descricao);
    const res = await api.post(`/orcamento-meta/meta/${metaId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/orcamento-meta/${id}`);
  },

  viewUrl: (id: string): string => {
    const base = (api.defaults.baseURL ?? '/api').replace(/\/$/, '');
    return `${base}/orcamento-meta/${id}/view`;
  },
};

export default orcamentoMetaService;